module.exports = __webpack_public_path__ + "static/media/ril.0aee07d6.png";